<template>
  <v-container fluid class="ma-4 px-8">
    <v-row justify="start" align="center">
      <v-col cols="12" md="3" class="py-0 my-0">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="displayDate"
              readonly
              outlined
              label="Date Range"
              dense
              v-bind="attrs"
              v-on="on"
              hide-details="auto"
            ></v-text-field>
          </template>
          <v-sheet
            class="pa-4"
            elevation="4"
            style="background-color: white; border-radius: 8px"
          >
            <v-row no-gutters>
              <v-col>
                <v-date-picker
                  v-model="selectedDates"
                  range
                  @input="onDateChange"
                ></v-date-picker>
              </v-col>

              <v-col class="pl-4 pt-4" style="max-width: 150px">
                <div
                  v-for="option in dateOptions"
                  :key="option.label"
                  class="mb-2 pt-2"
                >
                  <v-btn small color="accent" @click="setQuickDate(option)">
                    {{ option.label }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
        </v-menu>
      </v-col>
      <v-col cols="12" md="2" class="py-0 my-0">
        <v-select
          v-model="form.year_batch"
          :items="batches"
          outlined
          dense
          hide-details="auto"
          label="Batch"
          @change="getPrograms()"
          clearable
        ></v-select>
      </v-col>
      <v-col cols="12" md="2" class="py-0 my-0">
        <v-autocomplete
          v-model="form.filter_by"
          :items="filterBy"
          item-text="text"
          item-value="value"
          outlined
          dense
          hide-details="auto"
          label="Filter By"
          @change="
            (form.payment_status = null),
              (form.application_status = null),
              (reportData = [])
          "
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col
        v-if="form.filter_by == 'application'"
        cols="12"
        md="2"
        class="py-0 my-0"
      >
        <v-autocomplete
          v-model="form.application_status"
          :items="statuses"
          item-text="text"
          item-value="value"
          outlined
          dense
          hide-details="auto"
          label="Application Status"
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="2" class="py-0 my-0">
        <v-text-field
          v-model="form.mobile_no"
          outlined
          label="Mobile Number"
          :rules="[rules.mobile]"
          maxlength="10"
          dense
          hide-details
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="2" class="py-0 my-0">
        <v-autocomplete
          v-model="form.program_id"
          :items="programs"
          :item-text="
            (item) =>
              `${item.degree.short_name} ${
                item.specialization ? `- ${item.specialization}` : ''
              }`
          "
          item-value="id"
          outlined
          dense
          hide-details="auto"
          label="Programme"
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="2" class="py-0 my-0">
        <v-autocomplete
          v-model="form.partner_id"
          :items="partners"
          item-text="name"
          item-value="id"
          outlined
          dense
          hide-details="auto"
          label="Partner"
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn
          :loading="loading"
          class="accent white--text mr-2"
          @click="search"
        >
          Search
        </v-btn>
        <v-btn
          :disabled="!reportData.length"
          class="accent white--text ml-2"
          @click="download"
        >
          <v-icon>mdi-download</v-icon> Download
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table :headers="headers" :items="reportData" fixed-header>
            <template v-slot:no-data>
              <div class="text-center">No data available</div>
            </template>
            <template v-slot:[`item.admitted_date`]="{ item }">
              {{ item.admitted_date ? item.admitted_date : "-" }}
            </template>
            <template v-slot:[`item.submitted_date`]="{ item }">
              {{ item.submitted_date ? item.submitted_date : "-" }}
            </template>
            <template v-slot:[`item.approved_at`]="{ item }">
              {{ item.approved_at ? item.approved_at : "-" }}
            </template>
            <template v-slot:[`item.provisionally_approved_at`]="{ item }">
              {{
                item.provisionally_approved_at
                  ? item.provisionally_approved_at
                  : "-"
              }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { rules } from "@/helpers/rules";
import { applicationStatusHeaders } from "@/constants/headers";

export default {
  components: {},
  data() {
    return {
      menu: false,
      selectedDates: [],
      displayDate: "",
      form: {
        from_date: "",
        to_date: "",
        program_id: null,
        partner_id: null,
        filter_by: "pre_application",
        payment_status: null,
        application_status: null,
        year_batch: null,
      },
      filterBy: [
        { text: "Pre Application", value: "pre_application" },
        { text: "Application", value: "application" },
      ],
      statuses: [
        "Draft",
        "Submitted",
        "Approved",
        "Rejected",
        "Provisionally Approved",
        "Admitted",
        "Pending",
        "Re-Submitted",
      ],
      dateOptions: [
        { label: "Today", days: 0 },
        { label: "Yesterday", type: "yesterday" },
        { label: "This Week", type: "week" },
        { label: "Last 7 Days", days: 6 },
        { label: "This Month", type: "month" },
        { label: "Last 30 Days", days: 29 },
        { label: "Reset", type: "reset" },
      ],
      reportData: [],
      headers: [],
      applicationStatusHeaders,
      rules,
      partners: [],
      programs: [],
      users: [],
      loading: false,
      batches: [],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    formatDate() {
      return (date) => {
        let newDate = new Date(date);

        const day = String(newDate.getDate()).padStart(2, "0");
        const month = String(newDate.getMonth() + 1).padStart(2, "0");
        const year = newDate.getFullYear();
        return `${day}-${month}-${year}`;
      };
    },
    formatDateBackend() {
      return (date) => {
        let newDate = new Date(date);

        const day = String(newDate.getDate()).padStart(2, "0");
        const month = String(newDate.getMonth() + 1).padStart(2, "0");
        const year = newDate.getFullYear();
        return `${year}-${month}-${day}`;
      };
    },
  },
  watch: {
    form: {
      handler() {
        this.reportData = [];
      },
      deep: true,
    },
  },
  async created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Application Status" }]);
    await this.generateBatchList();
    this.init();
    this.search();
  },
  methods: {
    async init() {
      Promise.all([this.getPartners(), this.getPrograms(), this.getUsers()]);
    },
    async search() {
      this.loading = true;
      const queryString = this.objectToQueryParams({
        ...this.form,
      });

      await this.$axios
        .get(`/list_application_status?${queryString}`)
        .then((res) => {
          this.init();
          this.reportData = res.data.data;
          this.headers = applicationStatusHeaders.filter(
            (h) =>
              !this.form[h.value] ||
              this.form[h.value] === "" ||
              this.form[h.value] === null,
          );
          // if (this.form.filter_by === "pre_application") {
          //   this.headers = [
          //     ...this.headers,
          //     {
          //       text: "Application Started",
          //       value: "application_started",
          //       class: "black--text font-weight-bold secondary",
          //     },
          //   ];
          // }
          if (this.form.filter_by === "application") {
            this.headers = [
              ...this.headers,
              {
                text: "Submitted At",
                value: "submitted_date",
                class: "black--text font-weight-bold secondary",
              },
              {
                text: "Provisionally Approved At",
                value: "provisionally_approved_at",
                class: "black--text font-weight-bold secondary",
              },
              {
                text: "Approved At",
                value: "approved_at",
                class: "black--text font-weight-bold secondary",
              },
              {
                text: "Admitted At",
                value: "admitted_date",
                class: "black--text font-weight-bold secondary",
              },
              {
                text: "Reviewed By",
                value: "reviewed_user",
                class: "black--text font-weight-bold secondary",
              },
            ];
          } else {
            this.headers = this.headers.filter(
              (item) =>
                item.value != "application_id" &&
                item.value != "application_status",
            );
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    objectToQueryParams(obj) {
      if (obj.year_batch) {
        const [year, batch] = obj.year_batch.split("-");
        obj.year = year;
        obj.batch = batch;
        delete obj.year_batch;
      }
      return Object.keys(obj)
        .filter(
          (key) =>
            obj[key] !== undefined && obj[key] !== null && obj[key] !== "",
        ) // Remove undefined/null values
        .map(
          (key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]),
        )
        .join("&");
    },
    formatDisplayDate(from, to) {
      return `${this.formatDate(from)}~${this.formatDate(to)}`;
    },
    onDateChange() {
      if (this.selectedDates.length === 2) {
        const [fromDate, toDate] = this.selectedDates;

        this.form.from_date = this.formatDateBackend(fromDate);
        this.form.to_date = this.formatDateBackend(toDate);

        this.displayDate = this.formatDisplayDate(fromDate, toDate);
      }
    },
    setQuickDate(option) {
      if (option.type === "reset") {
        this.form.from_date = null;
        this.form.to_date = null;
        this.displayDate = "";
        this.selectedDates = [];
        return;
      }
      const today = new Date();
      let fromDate = new Date(today);
      let toDate = new Date(today);

      if (option.type === "week") {
        fromDate.setDate(today.getDate() - today.getDay());
      } else if (option.type === "month") {
        fromDate.setDate(1);
      } else if (option.type === "yesterday") {
        fromDate.setDate(today.getDate() - 1);
        toDate.setDate(today.getDate() - 1);
      } else if (option.days) {
        fromDate.setDate(today.getDate() - option.days);
      }

      this.selectedDates = [
        this.formatDateBackend(fromDate),
        this.formatDateBackend(toDate),
      ];

      this.onDateChange();
    },
    async getPrograms() {
      try {
        const [year, batch] = this.form.year_batch.split("-");
        const url = `/get_batch_programs/${year}/${batch}`;
        const response = await this.$axios.get(url);
        this.programs = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    getProgramName(id) {
      const program = this.programs.find((p) => p.id === id);
      return program
        ? program.degree.short_name +
            (program.specialization ? " - " + program.specialization : "")
        : "";
    },
    async getPartners() {
      try {
        const response = await this.$axios.get("/partners");
        this.partners = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    getPartnerName(id) {
      const partner = this.partners.find((partner) => partner.id === id);
      return partner ? partner.name : "";
    },
    async getUsers() {
      try {
        const response = await this.$axios.get("/users");
        this.users = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    getUserName(userId) {
      const user = this.users.find((user) => user.id === userId);
      return user ? user.first_name + " " + user.last_name : "";
    },
    async download() {
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      this.$axios
        .get(`/download_application_status?${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Application status.csv");
          document.body.appendChild(link);
          link.click();
        });
    },
    async generateBatchList() {
      try {
        const response = await this.$axios.get("/get_year_batch");
        this.batches = response.data.data;
        this.form.year_batch = this.batches[0];
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.v-data-table::v-deep td {
  font-size: 12px !important;
  padding-right: 0px !important;
}
</style>
